export function SettingsExtras() {
  return (
    <p className="settings-help">
      Edit topics and clear coverage from the main screen — they're shared with the whole room.
    </p>
  );
}
